import React, { useEffect, useMemo } from 'react';
import ActivityLoader from '../Common/ActivityLoader';
import { useConfig } from '../../DataStore/ConfigContext';

const isActive = (s) => String(s || '').toLowerCase() === 'active';

const Signatory = () => {
  const { getSignatories, signatories, preferences, loadingSignatories } = useConfig();

  useEffect(() => {
    getSignatories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const activeList = useMemo(() => {
    const list = Array.isArray(signatories) ? signatories : [];
    return list.filter((s) => isActive(s.status));
  }, [signatories]);


  // Respect preference flag (keyed-object format)
  if (
    preferences &&
    preferences.show_signatories &&
    String(preferences.show_signatories.preference_value).toUpperCase() === 'NO'
  ) {
    return <div />;
  }

  
  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: activeList.length > 0 ? 'space-between' : 'center',
        marginTop: '30px',
        gap: '24px',
        flexWrap: 'wrap',
      }}
    >
      {loadingSignatories && <ActivityLoader />}

      {!loadingSignatories && activeList.length === 0 && (
        <div className="text-muted small">No active signatories.</div>
      )}

      {!loadingSignatories &&
        activeList.map((item) => (
          <div key={item.id} style={{ minWidth: 180 }}>
            <div style={{ fontSize: '12px', textTransform: 'uppercase', letterSpacing: '.02em' }}>
              {item.designation}
            </div>
            <div style={{ marginTop: '10px' }}>.......................</div>
            <div style={{ fontWeight: 'bold', fontSize: '12px', marginTop: '6px' }}>
              {`${item.last_name || ''} ${item.first_name || ''}`.trim()}
            </div>
          </div>
        ))}
    </div>
  );
};

export default Signatory;
